import React, { createContext, useContext, useMemo, useState, useEffect } from "react";
import { ThemeProvider, CssBaseline, createTheme } from "@mui/material";
import { THEMES } from "../themes/defaultTheme";

const ThemeContext = createContext();

export const useThemeMode = () => useContext(ThemeContext);

export const ThemeContextProvider = ({ children }) => {
  const [mode, setMode] = useState("light");
  const [themeKey, setThemeKey] = useState("merubot");

  const toggleTheme = () => setMode((prev) => (prev === "light" ? "dark" : "light"));

  const theme = useMemo(() => {
    // 1. Get the theme group (e.g., MeruBot)
    const themeGroup = THEMES[themeKey] || THEMES.merubot;
    
    // 2. Select the specific variant based on mode
    // If the dark variant doesn't exist for a theme, it falls back to light
    const base = themeGroup[mode] || themeGroup.light;

    // 3. Return the fully formed theme
    return createTheme({
      ...base,
      palette: {
        ...base.palette,
        mode, // Ensure the palette mode stays in sync
      },
    });
  }, [mode, themeKey]);

  return (
    <ThemeContext.Provider value={{ mode, toggleTheme, themeKey, setThemeKey, themeOptions: THEMES }}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </ThemeProvider>
    </ThemeContext.Provider>
  );
};